import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import styled from "styled-components";
import { TitleText } from "../../../ui/Text";
import Table from "../../../ui/Table";
import Modal from "../../../ui/Modal";
import TableFormatter, {
  EditDeleteFormatter,
} from "../../../ui/TableFormatter";
import AddScorecardForm from "./AddScorecardForm";
import { useRouteMatch, useLocation } from "react-router-dom";
import { get } from "../../../utils/get";
import axios from "../../../utils/axios";
import {
  SCORECARDS_URL,
  PERIOD_URL,
  USER_URL,
  ORGANISATION_URL,
  SCORECARD_URL,
} from "../../../api/urls";
import { GetHook } from "../../../api/api";
import { parseDropdown } from "../../../utils/parseDropdown";
import { AuthContext } from "../../../context/AuthContext";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import useAuth from "../../../hooks/useAuth";
// import Header from "../components/Header";

interface FilterState {
  owner?: string;
  period?: string;
  organisation?: string;
  organisation_id?: string;
  status?: string;
  scorecardType?: string;
  // Add any other filter properties you use
}

const ScorecardListView = (props) => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [handleSubmit, setHandleSubmit] = useState();
  const [editData, setEditData] = useState({});
  const [edit, setEdit] = useState(false);
  const [scorecards, setScorecards] = useState([]);
  const [filter, setFilter] = useState<FilterState>();
  const [filterEndpoint, setFilterEndpoint] = useState("");
  const [pageCount, setPageCount] = useState(0);
  
  const location = useLocation();
  const auth = useAuth();

  const { isAdmin, authState } = auth;

  const endPoint = !isAdmin()
    ? `&owner_id=${get(authState, "user.id")}&show_children=True`
    : "";

  let initialFilter = "";
  if (get(location, "pathname").includes("active"))
    initialFilter = "status=active"; // Add parameter name
  if (get(location, "pathname").includes("archived"))
    initialFilter = "status=archived"; // Add parameter name
  if (get(location, "pathname").includes("pending")) {
    initialFilter = "include_status=draft&include_status=pending-approval";
  }

  const { data, error, pending, reload, availableResultSet } = GetHook(
    `${SCORECARDS_URL}?limit=10${endPoint}`
  );
  const [dataSize, setDataSize] = useState(() => availableResultSet || 0);
  const { data: periods } = GetHook(PERIOD_URL);
  const { data: owners } = GetHook(`${USER_URL}?limit=1000`);
  const { data: organisations } = GetHook(ORGANISATION_URL);

  const { url, path } = useRouteMatch();

  useEffect(() => {
    if (data) {
      setScorecards(data?.returned_resultset || []);
      setDataSize(data?.available_resultset_size || 0);
      setPageCount(Math.ceil((data?.available_resultset_size || 0) / 10));
    }
  }, [data]);

  useEffect(() => {
    const filterParts: string[] = [];
    
    // These values already contain the full parameter string from the Table component
    Object.entries(filter || {}).forEach(([key, value]) => {
      if (value) {
        filterParts.push(value as string);
      }
    });
    
    setFilterEndpoint(filterParts.join('&'));
  }, [filter]);

  console.log(filter);

  const handleEdit: any = (e, row: any) => {
    // e.stopPropagation();
    setisModalOpen(true);
    setEdit(true);
    setEditData(row);
  };

  const { history } = props;
  const closeModal = () => {
    setisModalOpen(false);
    setEdit(false);
    setEditData({});
    reload(get(location, "key"));
  };

  const setScorecard = (rowobject) => {
    const { id } = get(rowobject, "original");
    history.push(`${url}/${id}`);
  };


  //Handle api pagination

  const paginationIdRef = useRef(0);

  const handlePagination = useCallback(({ pageSize, pageIndex }) => {
    const currentIndex = pageIndex * pageSize;
    
    let url = `${SCORECARDS_URL}?limit=${pageSize}&offset=${currentIndex}`;
    
    // Handle initial filter based on URL path
    if (initialFilter) {
      url += `&${initialFilter}`;
    }
    
    // Add user-specific filter for non-admins
    if (!isAdmin() && !filter?.owner) {
      url += `&owner_id=${get(authState, "user.id")}&show_children=True`;
    }
    
    // Add other filters
    if (filterEndpoint) {
      url += `&${filterEndpoint}`;
    }
    
    axios.get(url)
      .then((res) => {
        setScorecards(res?.data?.returned_resultset || []);
        setDataSize(res?.data?.available_resultset_size || 0);
        setPageCount(Math.ceil((res?.data?.available_resultset_size || 0) / pageSize));
      })
      .catch((error) => {
        console.error('API error:', error);
        toast.error('Failed to load data');
      });
  }, [filterEndpoint, initialFilter, isAdmin, authState, filter?.owner]);

  const handleDelete = (e, id: string) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          axios
            .delete(`${SCORECARD_URL}/${id}`)
            .then((res) => {
              setScorecards(scorecards.filter((org: any) => org.id !== id));
              toast.success("Scorecard has been deleted");
              reload(get(location, "key"));
            })
            .catch((error) => toast.error(error?.response?.data.message));
        }
      }
    });
  };

  const columns = [
   
    {
      Header: "Owner",
      accessor: "owner.names",
    },
    {
      Header: "Period",
      accessor: "period.name",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Scorecard Type",
      accessor: "scorecard_type",
    },
    {
      Header: "Notes",
      accessor: "notes",
    },
    {
      id: "1",
      Header: "",
      Cell: ({ row }: any) => {
        return initialFilter !== "active" ? (
          <EditDeleteFormatter
            isArchived={row.original.status === "archived"}
            isActive={row.original.status === "active"}
            showEdit={(e) => handleEdit(e, row.original)}
            handleDelete={(e) => handleDelete(e, row.original.id)}
          />
        ) : null;
      },
    },
  ];

  return (
    <Container>
      <HeaderContainer>
        <TitleText>Scorecards</TitleText>
      </HeaderContainer>
      <Table
        data={scorecards}
        columns={columns}
        setModal={setisModalOpen}
        setScorecard={setScorecard}
        periods={parseDropdown(periods)}
        isScorecard
        dataSize={dataSize}
        handlePagination={handlePagination}
        pageCount={pageCount}
        owners={parseDropdown(
            get(filter, "organisation")
            ? owners.filter(
                (owner) =>
                owner.organisation_id === get(filter, "organisation_id")
            )
            : owners
        )}
        organisations={parseDropdown(organisations)}
        filter={filter}
        setFilter={setFilter}
      />
      {isModalOpen && (
        <Modal
          title={edit ? "Edit scorecard" : "Add new scorecard ."}
          handleSubmit={handleSubmit}
          closeModal={closeModal}
        >
          <AddScorecardForm
            closeModal={closeModal}
            setHandleSubmit={setHandleSubmit}
            setScorecards={setScorecards}
            scorecards={scorecards}
            editData={editData}
            isPIP = { history.isPIP }
          />
        </Modal>
      )}
    </Container>
  );
};

export default ScorecardListView;

const Container = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
  background-color: #fff;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.3em;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
`;
